import { OperatorsState, StoreAction } from '../../interfaces/redux.interface';
import * as operatorsActions from '../constants/operatorsActions';

const initialState: OperatorsState = {
	operators: [],
};

const operatorsReducer = (
	state: typeof initialState = initialState,
	action: StoreAction<any>,
): OperatorsState => {
	switch (action.type) {
		case operatorsActions.GET_OPERATORS_SUCCESS:
			return {
				...state,
				operators: action.payload,
			};
		default:
			return state;
	}
};

export default operatorsReducer;
